import React from 'react';
import { useTranslation } from 'react-i18next';
import emeraldIcon from 'assets/signature-plans/emerald.svg';
import rubyIcon from 'assets/signature-plans/ruby.svg';
import diamondIcon from 'assets/signature-plans/diamond.svg';
import SignaturePlanTile from './SignaturePlanTile';
import { SignaturePlanListStyled } from './SignaturePlanList.styled';

const PLAN_VISUALS = {
    emerald: { icon: emeraldIcon, iconBackground: '#ecf8f3' },
    ruby: { icon: rubyIcon, iconBackground: '#fff6f8' },
    diamond: { icon: diamondIcon, iconBackground: '#b8d7d4' },
};

const formatUsd = (amount) => `$${amount.toLocaleString('en-US')}`;

// The three Signature Collection plan cards. `plans` comes from useSignaturePlans.
const SignaturePlanList = ({ plans, selectedPlanKey = null, onChoose, isBusy = false }) => {
    const { t } = useTranslation();

    return (
        <SignaturePlanListStyled>
            {plans.map((plan) => (
                <SignaturePlanTile
                    key={plan.planKey}
                    planKey={plan.planKey}
                    icon={PLAN_VISUALS[plan.planKey].icon}
                    iconBackground={PLAN_VISUALS[plan.planKey].iconBackground}
                    priceLabel={`${formatUsd(plan.annualPrice)}${t('SignaturePlans.Period')}`}
                    isSelected={selectedPlanKey === plan.planKey}
                    isBusy={isBusy}
                    onChoose={() => onChoose(plan)}
                />
            ))}
        </SignaturePlanListStyled>
    );
};

export default SignaturePlanList;
